import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Container from "@mui/material/Container";

import Info from "./info";

const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 0, pb: 2 };

export default function ChefCorner() {

  return (
    <React.Fragment>
  <div>
        <Box sx={sxHeroContent}>
          <Container maxWidth="md">
            <Typography
              component="h1"
              variant="h3"
              align="center"
              color="textPrimary"
              gutterBottom
            >
              CoffeeWithMe ☕
            </Typography>
            <Typography
              variant="h6"
              align="center"
              color="textSecondary"
              paragraph
            >
              Have a question or want to work together or if you just want to
              connect with me?
            </Typography>
          </Container>
  </Box>
  <Container sx={sxCardGrid} maxWidth="xl">
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={6}>
              <Info />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <img
                style={{ borderRadius: "50%", marginLeft: "15%" }}
                width="52%"
                height="90%"
                src={"avatar.PNG"}
                alt={"item.title"}
                loading="lazy"
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </React.Fragment>
  );
}
